<style scoped>
</style>

<template>
  <div>
    <h1
      v-if="projectNoExistMsg.length > 0"
      style="text-align:center;font-size:40px;margin-top:50px"
    >{{projectNoExistMsg}}</h1>
    <div v-else>
      <Menu
        mode="horizontal"
        :active-name="currentMenuName"
        style="overflow:hidden"
        @on-select="menuSelect"
      >
        <img src="../../assets/epoint_logo_1.png" style="float:left;height:60px;padding:20px 20px" />
        <h3 style="float:left;color:black">{{projectname}}</h3>
        <!-- <Button size="small" style="margin-left:10px" @click="share">分享</Button> -->

        <Button
          size="small"
          style="margin-left:10px"
          @click="addAttention"
          v-if="!isAttention"
          icon="md-heart-outline"
        >添加关注</Button>
        <Button
          icon="md-heart"
          size="small"
          style="margin-left:10px;color:red"
          @click="removeAttention"
          v-if="isAttention"
        >取消关注</Button>
        <Button
          size="small"
          style="margin-left:10px"
          @click="back2List"
          icon="md-return-left"
          type="primary"
        >返回</Button>
        <!-- <MenuItem name="5" style="float:right">
        <Icon type="ios-app"/>文档管理
      </MenuItem>
      <MenuItem name="4" style="float:right">
        <Icon type="ios-app"/>问题跟踪
        </MenuItem>-->
        <MenuItem name="/appdistv2" style="float:right">
          <Icon type="ios-app" />发版管理
        </MenuItem>
        <!-- <MenuItem name="/appdist" style="float:right">
          <Icon type="ios-app"/>发版管理
        </MenuItem>-->
        <!-- <MenuItem name="/appmanagev2" style="float:right">
          <Icon type="ios-app"/>应用管理
        </MenuItem>-->
        <MenuItem name="/appmanage" style="float:right">
          <Icon type="ios-app" />应用管理
        </MenuItem>
        <!-- <MenuItem name="/projecttags" style="float:right">
          <Icon type="ios-app"/>项目标签
        </MenuItem>-->
        <!-- <MenuItem name="/projectplan" style="float:right">
          <Icon type="ios-app"/>项目计划
        </MenuItem>-->
        <MenuItem name="/projectoverview" style="float:right">
          <Icon type="ios-app" />项目概览
        </MenuItem>
      </Menu>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentMenuName: "",
      detail: {},
      projectguid: this.$route.params.projectguid,
      projectname: "",
      pmname: "",
      isProjectExist: true,
      projectNoExistMsg: "",
      isAttention: false
    };
  },
  methods: {
    //返回到项目列表
    back2List() {
      // this.$router.go(-1);
      this.$router.replace("/projectall");
    },
    menuSelect(name) {
      this.$router.push(name + "/" + this.projectguid);
    },
    loadBasicProjectInfo() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/get",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          document.title = data.projectname;
          _this.projectname = data.projectname;
          _this.pmname = data.pmname;
        },
        failure(code, msg) {
          _this.projectNoExistMsg = msg;
        }
      });
    },
    addAttention() {
      let _this = this;
      this.$http.post({
        method: "mqms/project/attention/add",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.queryAttention();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    queryAttention() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/attention/isattention",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.isAttention = data;
        },
        failure(code, msg) {}
      });
    },
    removeAttention() {
      let _this = this;
      this.$http.post({
        method: "mqms/project/attention/remove",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.queryAttention();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    }
  },
  mounted() {
    let index = this.$route.path.lastIndexOf("/");
    this.currentMenuName = this.$route.path.substr(0, index);
    this.loadBasicProjectInfo();
    this.queryAttention();
  }
};
</script>